import React from "react";

const IconEllipsis = () => (
	<svg fill="none" xmlns="http://www.w3.org/2000/svg" width="13" height="3" viewBox="0 0 13 3">
		<path opacity=".5" fillRule="evenodd" clipRule="evenodd" d="M3 1.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm5 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM11.5 3a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" fill="#000"/>
	</svg>
);

export default IconEllipsis;
